import {hot} from 'react-hot-loader';
import React from 'react';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import {Provider} from 'react-redux';
import config from '../../config';
import Main from './Main';

const App = ({store}) => {
    return (
        <Provider store={store}>
            <Router basename={config.publicPath}>
                <Route component={Main} />
            </Router>
        </Provider>
    );
};

export default hot(module)(App);
